import Settings from "utils/CarrotConfig"

export const getCompanyViewLink = (companyId: string): string => {
  return `${Settings.CARROT_BACKEND_ADMIN_URL}/Admin/Companies/${companyId}`
}
